import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import Heading from '@vfuk/core-heading';
import {
  bgWhite,
  bgAbbey,
  imageBlock,
  articleSummary
} from './styles/Article.styles';
import RichTextElement from '../pageBuilder/Elements/RichText';
import Icon from '@vfuk/core-icon';
import CardProps from './types/Card.types';
import {
  iconsAndTextContainer,
  iconTextStyle,
  redSmallDateStyling,
  textBlock
} from './styles/Card.styles';

const Card = ({ data, backgroundColor = 'white' }: CardProps) => {
  const { name, cardSummary, mainImage, iconsAndText = [] } = data;
  const backgroundColorCSS = backgroundColor === 'white' ? bgWhite : bgAbbey;

  const iconTextRow = iconsAndText?.map(icon => {
    return (
      <div key={icon.id} css={iconTextStyle} style={{ color: icon.color }}>
        <Icon
          name={icon.iconRef}
          size={icon.iconSize}
          appearance={icon.appearance || "primary"}
          inverse={icon.inverse}
        />
        <span>{icon.label}</span>
      </div>
    );
  });

  let redSmallDate;

  if (cardSummary && cardSummary.raw) {
    const parsedRawSummary = JSON.parse(cardSummary.raw);
    for (const content of parsedRawSummary.content) {
      for (const subContent of content.content) {
        if (
          subContent.value &&
          typeof subContent.value === 'string' &&
          subContent.value.includes('redSmallDate:')
        ) {
          redSmallDate = subContent.value;
          const redSmallDateIndex = content.content.findIndex(
            (subContent: any) => {
              return subContent.value.includes('redSmallDate:');
            }
          );
          redSmallDate = redSmallDate.replace('redSmallDate:', '');
          content.content.splice(redSmallDateIndex);
          cardSummary.raw = JSON.stringify(parsedRawSummary);
        }
      }
    }
  }

  return (
    <div css={articleSummary}>
      <div
        css={backgroundColorCSS}
        style={{ height: '100%', position: 'relative' }}
        className="card_resize card"
        data-testid={`card-${name}`}
      >
        {mainImage && (
          <GatsbyImage
            image={getImage(mainImage) as IGatsbyImageData}
            css={imageBlock}
            alt={mainImage.description}
          />
        )}
        <div css={textBlock}>
          {redSmallDate && <div css={redSmallDateStyling}>{redSmallDate}</div>}
          <Heading text={name} weight={2} size={2} noMargin={true} />
          <RichTextElement rawRichText={cardSummary?.raw} />
        </div>
        <div css={iconsAndTextContainer}>
          {iconsAndText?.length > 0 && iconTextRow}
        </div>
      </div>
    </div>
  );
};

export default Card;
